import { gql } from '@apollo/client';

export const UPSERT_FRAMEWORKRESULT = gql`
  mutation upsertFrameworkResult($input: UpsertFrameworkResultInput!) {
    frameworkResult: upsertFrameworkResult(input: $input) {
      id
    }
  }
`;
